export default __webpack_public_path__ + "static/media/EAST1060.34I-34289_-18545_0.d71a4caf.jpg";